import { authRequest } from "../utils/netRequest";

export class PlacesService {
  async airline(iata) {
    return await authRequest({
      url: `/places/airports/${iata}}`,
      method: "get",
    });
  };

  async getSavedPlaces() {
    return await authRequest({
      url: '/places/saved',
      method: 'get',
    });
  };

  async addSavedPlace(place) {
    return await authRequest({
      url: '/places/saved',
      method: 'put',
      data: place,
    });
  };

  async deleteSavedPlace(id) {
    return await authRequest({
      url: `/places/saved/${id}`,
      method: 'delete',
    });
  };

  async recentPlaces() {
    return await authRequest({
      url: '/places/recent',
      method: 'get',
    });
  };

}

export default new PlacesService();


